module.exports = __webpack_public_path__ + "img/23.283a980b.jpg";